;(function () {
    const wraps = document.querySelectorAll('.js-offers-calc__custom-select')
    if (!wraps.length) return

    const closeFns = new WeakMap()
    let globalListenersBound = false

    function bindGlobalListeners() {
        if (globalListenersBound) return
        globalListenersBound = true

        document.addEventListener('click', (e) => {
            document.querySelectorAll('.js-offers-calc__custom-select.is-open').forEach((w) => {
                if (!w.contains(e.target)) closeFns.get(w)?.()
            })
        })

        document.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') return
            document.querySelectorAll('.js-offers-calc__custom-select.is-open').forEach((w) => {
                closeFns.get(w)?.()
            })
        })
    }

    function initCustomSelect(wrap) {
        const select = wrap.querySelector('.offers-calc__select-native')
        const trigger = wrap.querySelector('.offers-calc__select-trigger')
        const listbox = wrap.querySelector('.offers-calc__select-listbox')
        const options = wrap.querySelectorAll('.offers-calc__select-option')
        const valueEl = trigger?.querySelector('.offers-calc__select-value')

        if (!select || !trigger || !listbox || !valueEl || !options.length) return

        function syncTriggerLabel() {
            const opt = select.options[select.selectedIndex]
            if (opt) valueEl.textContent = opt.text
        }

        function clearPanelEdgeClasses() {
            listbox.querySelectorAll('.offers-calc__select-option').forEach((btn) => {
                btn.classList.remove(
                    'offers-calc__select-option--first-in-panel',
                    'offers-calc__select-option--last-in-panel'
                )
            })
        }

        function reorderListboxForOpen() {
            const valueOrder = [...select.options].map((o) => String(o.value))
            const current = String(select.value)
            const buttons = [...listbox.querySelectorAll('.offers-calc__select-option')]
            const byValue = new Map(buttons.map((b) => [String(b.dataset.value), b]))
            const frag = document.createDocumentFragment()
            const selectedBtn = byValue.get(current)
            if (selectedBtn) frag.appendChild(selectedBtn)
            for (const v of valueOrder) {
                if (v === current) continue
                const b = byValue.get(v)
                if (b) frag.appendChild(b)
            }
            listbox.appendChild(frag)
        }

        function markPanelEdges() {
            clearPanelEdgeClasses()
            const buttons = [...listbox.querySelectorAll('.offers-calc__select-option')]
            if (!buttons.length) return
            buttons[0].classList.add('offers-calc__select-option--first-in-panel')
            buttons[buttons.length - 1].classList.add('offers-calc__select-option--last-in-panel')
        }

        function open() {
            document.querySelectorAll('.js-offers-calc__custom-select.is-open').forEach((w) => {
                if (w !== wrap) closeFns.get(w)?.()
            })
            wrap.classList.add('is-open')
            listbox.hidden = false
            trigger.hidden = true
            trigger.setAttribute('aria-expanded', 'true')
            syncTriggerLabel()
            reorderListboxForOpen()
            markPanelEdges()
        }

        function close() {
            wrap.classList.remove('is-open')
            listbox.hidden = true
            trigger.hidden = false
            trigger.setAttribute('aria-expanded', 'false')
            clearPanelEdgeClasses()
            syncTriggerLabel()
        }

        closeFns.set(wrap, close)

        trigger.addEventListener('click', (e) => {
            e.stopPropagation()
            if (wrap.classList.contains('is-open')) close()
            else open()
        })

        options.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation()
                if (String(btn.dataset.value) === String(select.value)) {
                    close()
                    return
                }
                select.value = btn.dataset.value
                select.dispatchEvent(new Event('change', { bubbles: true }))
                close()
            })
        })

        close()
    }

    bindGlobalListeners()
    wraps.forEach(initCustomSelect)
})()

;(function () {
    // ---- Config ----

    const FREQUENCY_CONFIG = {
        'monthly':     { min: 3,  max: 24, step: 1,  label: 'Ежемесячный платеж, ₽',       periodsPerYear: 12 },
        'quarterly':   { min: 3,  max: 24, step: 3,  label: 'Ежеквартальный платеж, ₽',    periodsPerYear: 4  },
        'half-yearly': { min: 6,  max: 24, step: 6,  label: 'Платеж раз в полгода, ₽',     periodsPerYear: 2  },
        'yearly':      { min: 12, max: 24, step: 12, label: 'Ежегодный платеж, ₽',         periodsPerYear: 1  },
    }

    const MIN_DOWN_PCT = {
        'monthly': {
            3: 20, 4: 25, 5: 30, 6: 35, 7: 37.5, 8: 40, 9: 42.5, 10: 45,
            11: 47.5, 12: 50, 13: 51.7, 14: 53.3, 15: 55, 16: 56.7,
            17: 58.3, 18: 60, 19: 61.7, 20: 63.3, 21: 65, 22: 66.7, 23: 68.3, 24: 70,
        },
        'quarterly':   { 3: 20, 6: 35, 9: 42.5, 12: 50, 15: 55, 18: 60, 21: 65, 24: 70 },
        'half-yearly': { 6: 35, 12: 50, 18: 60, 24: 70 },
        'yearly':      { 12: 50, 24: 70 },
    }

    const MAX_DOWN_PCT = 80

    // ---- Elements ----

    const lotNumberEl   = document.querySelector('.js-offers-calc__lot-number')
    const lotPriceEl    = document.querySelector('.js-offers-calc__lot-price')
    const lotRange      = lotPriceEl?.closest('.input-wrap--slider')?.querySelector('.offers-calc__range[type="range"]')
    const downInput     = document.querySelector('.js-offers-calc__down-payment')
    const pctBadge      = document.querySelector('.js-offers-calc__pct-badge')
    const downRange     = document.querySelector('.input-wrap--pct .offers-calc__range[type="range"]')
    const termInput     = document.querySelector('.js-offers-calc__term')
    const termRange     = termInput?.closest('.input-wrap--slider')?.querySelector('.offers-calc__range[type="range"]')
    const frequencySel  = document.querySelector('.js-offers-calc__frequency')
    const submitBtn     = document.querySelector('.offers-calc__submit')

    const annualLabelEl = document.querySelector('.js-offers-calc__right-annual-label')
    const annualEl      = document.querySelector('.js-offers-calc__right-annual-payment-value')
    const lineMainEl    = document.querySelector('.offers-calc__right-line__main')
    const lotValEl      = document.querySelector('.js-offers-calc__right-price__lot-value')
    const overpayEl     = document.querySelector('.js-offers-calc__right-price__overpayment-value')
    const totalEl       = document.querySelector('.js-offers-calc__right-total__value')

    if (!lotPriceEl) return

    const basePriceRows = Array.isArray(window.offersPriceBase) ? window.offersPriceBase : []
    const lotPriceUrl = typeof window.offersLotPriceUrl === 'string' ? window.offersLotPriceUrl : ''
    const defaultLotSotkas = Number(window.offersDefaultLotSotkas)

    let lastFetchedLotNumber = null
    let lotNumberAutoFetchTimer = null
    let currentLotSotkas = Number.isFinite(defaultLotSotkas) && defaultLotSotkas > 0 ? defaultLotSotkas : null
    const MIN_LOT_NUMBER_LEN_FOR_FETCH = 4
    const LOT_NUMBER_FETCH_DEBOUNCE_MS = 120

    // ---- Helpers ----

    function parseMoney(str) {
        const n = parseFloat(String(str).replace(/\s/g, '').replace(',', '.'))
        return Number.isFinite(n) ? n : 0
    }

    function formatMoneyInt(n) {
        return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(Math.round(n))
    }

    function parsePeriod(period) {
        const parts = String(period || '').split('.')
        if (parts.length !== 2) return null
        const month = parseInt(parts[0], 10)
        const year  = parseInt(parts[1], 10)
        if (isNaN(month) || isNaN(year) || month < 1 || month > 12) return null
        return year * 100 + month
    }

    // ---- State getters ----

    function getFrequency() { return frequencySel?.value || 'monthly' }
    function getTerm()      { return parseInt(termRange?.value || termInput?.value || '3', 10) }
    function getLotPrice()  { return parseMoney(lotPriceEl?.value) }
    function getDownPct()   { return parseFloat(downRange?.value || '20') }

    function clearLotPriceField() {
        if (lotPriceEl) lotPriceEl.value = ''
        currentLotSotkas = null
        if (lotRange) {
            const min = Number(lotRange.min)
            if (Number.isFinite(min)) lotRange.value = String(min)
        }
        updateDownPaymentRub()
    }

    function scheduleLotNumberPriceFetch() {
        if (!lotNumberEl || !lotPriceUrl) return
        clearTimeout(lotNumberAutoFetchTimer)
        const n = String(lotNumberEl.value).trim()
        if (n.length < MIN_LOT_NUMBER_LEN_FOR_FETCH) {
            lastFetchedLotNumber = null
            clearLotPriceField()
            return
        }
        lotNumberAutoFetchTimer = setTimeout(() => {
            lotNumberAutoFetchTimer = null
            void resolveLotNumberToPrice()
        }, LOT_NUMBER_FETCH_DEBOUNCE_MS)
    }

    async function resolveLotNumberToPrice() {
        if (!lotNumberEl || !lotPriceUrl) return
        const n = String(lotNumberEl.value).trim()
        if (!n) {
            lastFetchedLotNumber = null
            clearLotPriceField()
            return
        }
        if (n.length < MIN_LOT_NUMBER_LEN_FOR_FETCH) {
            lastFetchedLotNumber = null
            clearLotPriceField()
            return
        }
        if (n === lastFetchedLotNumber) return

        const res = await fetch(`${lotPriceUrl}?${new URLSearchParams({ lot_number: n })}`, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
        })
        const data = await res.json().catch(() => ({}))
        if (!res.ok || !data.ok || typeof data.price !== 'number') {
            lastFetchedLotNumber = null
            clearLotPriceField()
            return
        }

        lastFetchedLotNumber = n
        if (lotPriceEl) {
            lotPriceEl.value = formatMoneyInt(data.price)
            if (lotRange) {
                const min = Number(lotRange.min)
                const max = Number(lotRange.max)
                if (Number.isFinite(min) && Number.isFinite(max)) {
                    lotRange.value = String(Math.max(min, Math.min(max, data.price)))
                }
            }
        }
        const fetchedSotkas = Number(data.sotkas)
        currentLotSotkas = Number.isFinite(fetchedSotkas) && fetchedSotkas > 0 ? fetchedSotkas : null
        updateDownPaymentRub()
    }

    function getMinDownPct(frequency, term) {
        return MIN_DOWN_PCT[frequency]?.[term] ?? 20
    }

    // ---- Prices (настройка offers_price_base: период → прирост цены сотки для прогноза переплаты) ----

    function getGrowingForTerm(termMonths) {
        const entries = basePriceRows
        if (!Array.isArray(entries) || !entries.length) return []

        const sorted = entries
            .map(p => ({
                ym:      parsePeriod(p.period),
                growing: parseFloat(String(p.growing || '0').replace(/\s/g, '').replace(',', '.')) || 0,
            }))
            .filter(p => p.ym !== null)
            .sort((a, b) => a.ym - b.ym)

        if (!sorted.length) return []

        const now       = new Date()
        const currentYM = now.getFullYear() * 100 + (now.getMonth() + 1)

        let startIdx = sorted.findIndex(p => p.ym > currentYM)
        if (startIdx === -1) startIdx = sorted.length - 1

        const result = []
        for (let i = 0; i < termMonths; i++) {
            const idx = Math.min(startIdx + i, sorted.length - 1)
            result.push(sorted[idx].growing)
        }
        return result
    }

    // ---- Down payment sync ----

    function updateDownPaymentRub() {
        if (!downInput || !downRange) return
        const lot = getLotPrice()
        const pct = getDownPct()
        downInput.value = formatMoneyInt(lot * pct / 100)
        if (pctBadge) pctBadge.textContent = `${pct}%`
    }

    function syncDownPaymentFromInput() {
        if (!downInput || !downRange) return
        const lot = getLotPrice()
        if (!lot) return
        const rub    = parseMoney(downInput.value)
        const minPct = getMinDownPct(getFrequency(), getTerm())
        let pct      = (rub / lot) * 100
        pct = Math.max(minPct, Math.min(MAX_DOWN_PCT, pct))
        downRange.value = pct
        if (pctBadge) pctBadge.textContent = `${Math.round(pct * 10) / 10}%`
        downInput.value = formatMoneyInt(lot * pct / 100)
    }

    function enforceMinDownPayment() {
        if (!downRange) return
        const minPct = getMinDownPct(getFrequency(), getTerm())
        downRange.min = minPct
        downRange.step = '0.1'
        if (parseFloat(downRange.value) < minPct) {
            downRange.value = minPct
        }
        updateDownPaymentRub()
    }

    // ---- Term slider sync ----

    function updateTermForFrequency(frequency) {
        if (!termRange || !termInput) return
        const cfg = FREQUENCY_CONFIG[frequency] || FREQUENCY_CONFIG.monthly

        termRange.min  = cfg.min
        termRange.max  = cfg.max
        termRange.step = cfg.step

        let current = getTerm()
        let snapped = Math.round(current / cfg.step) * cfg.step
        snapped = Math.max(cfg.min, Math.min(cfg.max, snapped))
        if (snapped < cfg.min) snapped = cfg.min

        termRange.value = snapped
        termInput.value = String(snapped)
    }

    // ---- Calculation ----

    function calculate() {
        const lotPrice  = getLotPrice()
        const downPct   = getDownPct()
        const term      = getTerm()
        const frequency = getFrequency()

        if (!lotPrice || !term) return null

        const growings = getGrowingForTerm(term)
        if (!growings.length) return null

        if (!currentLotSotkas) return null

        const cfg            = FREQUENCY_CONFIG[frequency] || FREQUENCY_CONFIG.monthly
        const numSotkas      = currentLotSotkas
        const downPaymentRub = lotPrice * downPct / 100
        const basePricePerSotka = lotPrice / numSotkas
        if (!Number.isFinite(basePricePerSotka) || basePricePerSotka <= 0) return null

        let cumGrowing = 0
        const prices = growings.map(g => { cumGrowing += g; return basePricePerSotka + cumGrowing })
        const periodStep = cfg.step || 1
        const periodPrices = []
        for (let i = periodStep - 1; i < prices.length; i += periodStep) {
            periodPrices.push(prices[i])
        }
        const pricesForAverage = periodPrices.length ? periodPrices : prices
        const avgPrice = pricesForAverage.reduce((a, b) => a + b, 0) / pricesForAverage.length

        const paidSotkas    = downPaymentRub / basePricePerSotka
        const unpaidSotkas  = Math.max(0, numSotkas - paidSotkas)
        const remaining     = unpaidSotkas * avgPrice
        const totalLotCost  = downPaymentRub + remaining
        const overpayment   = totalLotCost - lotPrice
        const totalPeriods   = (term / 12) * cfg.periodsPerYear
        const periodicPayment = remaining / totalPeriods

        return { periodicPayment, lotPrice, overpayment, totalLotCost }
    }

    function updateFrequencyLabel() {
        if (!annualLabelEl) return
        const cfg = FREQUENCY_CONFIG[getFrequency()] || FREQUENCY_CONFIG.monthly
        annualLabelEl.textContent = cfg.label
    }

    function displayResults(result) {
        if (!result) return
        if (annualEl)   annualEl.textContent   = formatMoneyInt(result.periodicPayment)
        if (lotValEl)   lotValEl.textContent   = formatMoneyInt(result.lotPrice)
        if (overpayEl)  overpayEl.textContent  = formatMoneyInt(result.overpayment)
        if (totalEl)    totalEl.textContent    = formatMoneyInt(result.totalLotCost)

        if (lineMainEl && result.totalLotCost > 0) {
            const lotPct = Math.max(5, Math.min(90, (result.lotPrice / result.totalLotCost) * 100))
            lineMainEl.style.flex = `0 0 ${lotPct}%`
        }
    }

    // ---- Event listeners ----

    lotRange?.addEventListener('input', () => {
        lotPriceEl.value = formatMoneyInt(Number(lotRange.value))
        updateDownPaymentRub()
    })

    lotPriceEl?.addEventListener('blur', () => {
        const val = parseMoney(lotPriceEl.value)
        if (val > 0) {
            const min = lotRange ? Number(lotRange.min) : 0
            const max = lotRange ? Number(lotRange.max) : Infinity
            const clamped = Math.max(min, Math.min(max, val))
            lotPriceEl.value = formatMoneyInt(clamped)
            if (lotRange) lotRange.value = clamped
        }
        updateDownPaymentRub()
    })

    lotPriceEl?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            lotPriceEl.blur()
        }
    })

    downRange?.addEventListener('input', () => {
        enforceMinDownPayment()
    })

    downInput?.addEventListener('blur', () => {
        syncDownPaymentFromInput()
    })

    downInput?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            syncDownPaymentFromInput()
            downInput.blur()
        }
    })

    termRange?.addEventListener('input', () => {
        if (termInput) termInput.value = String(Number(termRange.value))
        enforceMinDownPayment()
    })

    frequencySel?.addEventListener('change', () => {
        updateTermForFrequency(getFrequency())
        enforceMinDownPayment()
        updateFrequencyLabel()
    })

    submitBtn?.addEventListener('click', async () => {
        await resolveLotNumberToPrice()
        displayResults(calculate())
    })

    lotNumberEl?.addEventListener('input', () => {
        scheduleLotNumberPriceFetch()
    })

    lotNumberEl?.addEventListener('blur', () => {
        clearTimeout(lotNumberAutoFetchTimer)
        lotNumberAutoFetchTimer = null
        void resolveLotNumberToPrice()
    })

    lotNumberEl?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            lotNumberEl.blur()
        }
    })

    // ---- Init ----

    updateTermForFrequency(getFrequency())
    enforceMinDownPayment()
    updateFrequencyLabel()
    if (lotRange) lotPriceEl.value = formatMoneyInt(Number(lotRange.value))
    else if (lotPriceEl) {
        const v = parseMoney(lotPriceEl.value)
        if (v > 0) lotPriceEl.value = formatMoneyInt(v)
    }
})()
